import { Card } from "react-bootstrap";
import SocialIcons from '../components/SocialIcons';

function TeamMember({ data }) {
    // Extract social links into an object
    const socials = {
        instagram: data.instagram_social,
        facebook: data.facebook_social,
        linkedin: data.linkedin_social,
        twitter: data.twitter_social,
    }

    return (
        <Card className="mx-auto border-0 px-3"
            style={{ maxWidth: "330px" }}
        >
            <Card.Img
                src={ data.image }
                alt={ data.name }
                style={{ maxHeight: "250px", objectFit: "cover" }}
            />
            <Card.Body className="d-flex flex-column gap-2 mt-2 px-0">
                <Card.Title as="h4" className="fw-semibold text-center">{ data.name }</Card.Title>
                <Card.Subtitle as="p" className="text-center">{ data.role }</Card.Subtitle>
                <SocialIcons links={ socials } />
            </Card.Body>
        </Card>
    )
}

export default TeamMember;
